import {
  __objRest
} from "./chunk-M54I523Y.js";

// packages/ui-lib/src/layout/getPaddingProps.ts
import cn from "classnames";

// packages/ui-lib/src/layout/space.css.ts
var padding = { none: "space_none__ntwn1sk", xs: "space_xs__ntwn1sl", small: "space_small__ntwn1sm", medium: "space_medium__ntwn1sn", large: "space_large__ntwn1so" };
var paddingBottom = { none: "space_none__ntwn1sf", xs: "space_xs__ntwn1sg", small: "space_small__ntwn1sh", medium: "space_medium__ntwn1si", large: "space_large__ntwn1sj" };
var paddingLeft = { none: "space_none__ntwn1s5", xs: "space_xs__ntwn1s6", small: "space_small__ntwn1s7", medium: "space_medium__ntwn1s8", large: "space_large__ntwn1s9" };
var paddingRight = { none: "space_none__ntwn1sa", xs: "space_xs__ntwn1sb", small: "space_small__ntwn1sc", medium: "space_medium__ntwn1sd", large: "space_large__ntwn1se" };
var paddingTop = { none: "space_none__ntwn1s0", xs: "space_xs__ntwn1s1", small: "space_small__ntwn1s2", medium: "space_medium__ntwn1s3", large: "space_large__ntwn1s4" };
var paddingX = { none: "space_none__ntwn1sp", xs: "space_xs__ntwn1sq", small: "space_small__ntwn1sr", medium: "space_medium__ntwn1ss", large: "space_large__ntwn1st" };
var paddingY = { none: "space_none__ntwn1su", xs: "space_xs__ntwn1sv", small: "space_small__ntwn1sw", medium: "space_medium__ntwn1sx", large: "space_large__ntwn1sy" };

// packages/ui-lib/src/layout/getPaddingProps.ts
function getPaddingProps(props) {
  const _a = props, { p, px, py, pr, pl, pt, pb } = _a, rest = __objRest(_a, ["p", "px", "py", "pr", "pl", "pt", "pb"]);
  const classNames = cn(p && padding[p], pb && paddingBottom[pb], pt && paddingTop[pt], pl && paddingLeft[pl], pr && paddingRight[pr], px && paddingX[px], py && paddingY[py]);
  return [classNames, rest];
}

export {
  getPaddingProps
};
//# sourceMappingURL=chunk-L7SHRNH5.js.map
